import request from "@/utils/request";
export function billingDetail(data) {
    return request({
        url: "/billing/detail",
        method: "GET",
        params: data
    });
}
export function packageList(data) {
    return request({
        url: "/billing/packageList",
        method: "GET",
        params: data
    });
}
export function overview() {
    return request({
        url: "/billing/overview",
        method: "GET"
    });
}
export function submitVoucher(data) {
    return request({
        url: "/billing/submitVoucher",
        method: "POST",
        data
    });
}
export function couponList(data) {
    return request({
        url: "/billing/couponList",
        method: "GET",
        params: data
    });
}
export function statistics(data) {
    return request({
        url: "/billing/statistics",
        method: "GET",
        params: data
    });
}
//对公汇款记录
export function businessRemitList(data) {
    return request({
        url: "/billing/businessRemitList",
        method: "GET",
        params: data
    });
}
// 汇款信息
export function remitInfo(data) {
    return request({
        url: "/billing/remitInfo",
        method: "GET",
        params: data
    });
}
//收支明细
export function tradeList(data) {
    return request({
        url: "/billing/tradeList",
        method: "GET",
        params: data
    });
}
//获取汇款子单元账号
export function getSubunit() {
    return request({
        url: "/billing/getSubunit",
        method: "GET"
    });
}
//资源类型 计费价下拉
export function itemDescs() {
    return request({
        url: "/resource/type/itemDescs",
        method: "GET"
    });
}
export function fetchAlipay(amount) {
    return request({
        url: "/billing/alipay",
        method: "POST",
        data: {
            amount,
            qr_pay_mode: "4",
            qrcode_width: "200"
        }
    });
}
export function alipayResult(tradeno) {
    return request({
        url: "/billing/alipayResult",
        method: "GET",
        params: { tradeno }
    });
}
// 账单总览
export function summary(data) {
    return request({
        url: "/billing/summary",
        method: "GET",
        params: data
    });
}
export function rechargeVoucher(data) {
    return request({
        url: "/billing/recharge_voucher",
        method: "POST",
        data
    });
}
